import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props extends ChildProps {
  quantity?: number
  selected?: boolean
  disabled?: boolean
  noPulldown?: boolean
  onClick?(e: React.MouseEvent<HTMLElement>): void
  onClickDelete?(e: React.MouseEvent<HTMLElement>): void
}

const SortButton = ({
  children,
  quantity,
  selected = false,
  disabled = false,
  noPulldown = false,
  onClick,
  onClickDelete
}: Props) => {
  return (
    <div className='inline-flex items-stretch justify-center'>
      <button
        type='button'
        className={clsx(
          'outline-default hover:bg-fill-emphasis-secondary-hover active:bg-fill-emphasis-secondary-active disabled:bg-surface-disabled inline-flex min-h-6.5 items-center py-1 focus:appearance-none disabled:pointer-events-none',
          selected && 'bg-fill-emphasis-secondary-active',
          onClickDelete !== undefined ? 'rounded-l-lg pr-1 pl-2' : 'rounded-lg px-2'
        )}
        disabled={disabled}
        onClick={onClick}
      >
        <Text
          color={disabled ? TextColor.DISABLED : TextColor.EMPHASIS}
          weight={selected ? 'bold' : 'normal'}
        >
          {children}
        </Text>
        {!!quantity && (
          <span
            className={clsx(
              'text-size-10 text-on-bg-fill ml-0.5 grid h-4 min-h-1 w-4 min-w-1 place-content-center rounded-full',
              disabled ? 'bg-fill-disabled' : 'bg-fill-emphasis'
            )}
          >
            {quantity}
          </span>
        )}
        {onClickDelete == undefined
          ? !noPulldown && (
              <Icon
                type={IconType.DOWN}
                color={disabled ? IconColor.DISABLED : IconColor.EMPHASIS}
              />
            )
          : ''}
      </button>
      {!!quantity && onClickDelete !== undefined && (
        <button
          className='bg-fill-emphasis-secondary-active disabled:bg-surface-disabled hover:bg-fill-emphasis-secondary-hover active:bg-fill-emphasis-secondary-active rounded-r-lg p-1'
          onClick={onClickDelete}
          disabled={disabled}
        >
          <Icon type={IconType.CLOSE} color={disabled ? IconColor.DISABLED : IconColor.EMPHASIS} />
        </button>
      )}
    </div>
  )
}

export default SortButton
